import { render, staticRenderFns } from "./insectParam.vue?vue&type=template&id=46bfe062&scoped=true&"
import script from "./insectParam.vue?vue&type=script&lang=js&"
export * from "./insectParam.vue?vue&type=script&lang=js&"
import style0 from "./insectParam.vue?vue&type=style&index=0&id=46bfe062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bfe062",
  null
  
)

export default component.exports